import { render } from "./ScoringAddress.vue?vue&type=template&id=163aee1e"
import script from "./ScoringAddress.vue?vue&type=script&lang=js"
export * from "./ScoringAddress.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__